import React from 'react'

export const Paris = ({ fill }) => (
    <svg version="1.1" viewBox="0 0 54.3158 78.6909" width="54.3158px" height="78.6909px">
<g fill={fill}>
   <g>
       <g>
           <path class="st0" d="M20.8542,60.615c-0.1421,0-0.2866-0.0244-0.4282-0.0752c-0.6484-0.2363-0.9824-0.9541-0.7461-1.6025
               c0.7407-2.0332,1.4214-4.1494,2.0801-6.1963c0.4028-1.252,0.7881-2.4502,1.1582-3.5361
               c0.1724-0.5059,0.6479-0.8467,1.1831-0.8467h6.1328c0.5352,0,1.0107,0.3408,1.1836,0.8467
               c0.3457,1.0146,0.6992,2.1484,1.0693,3.332c0.6719,2.1514,1.3672,4.376,2.1562,6.3672c0.2539,0.6426-0.0596,1.3691-0.7012,1.623
               c-0.6426,0.251-1.3691-0.0596-1.623-0.7012c-0.8232-2.0781-1.5322-4.3486-2.2188-6.5439
               c-0.2627-0.8418-0.5176-1.6592-0.7676-2.4238h-4.3325c-0.2778,0.8379-0.5645,1.7285-0.8604,2.6484
               c-0.666,2.0693-1.354,4.209-2.1113,6.2861C21.8439,60.3005,21.3645,60.615,20.8542,60.615z"/>
       </g>
   </g>
   <g>
       <path class="st0" d="M31.4724,17.9079c-0.6904,0-1.25-0.5596-1.25-1.25v-5.353c-0.9229-0.8071-2.314-1.7593-3.084-1.7593
           c-0.7646,0-2.126,0.9478-3.0254,1.751v5.3613c0,0.6904-0.5596,1.25-1.25,1.25s-1.25-0.5596-1.25-1.25v-5.9014
           c0-0.3315,0.1318-0.6494,0.3662-0.8838c0.4722-0.4722,2.9395-2.8271,5.1592-2.8271c2.2119,0,4.7256,2.3462,5.207,2.8169
           c0.2412,0.2349,0.377,0.5576,0.377,0.894v5.9014C32.7224,17.3484,32.1628,17.9079,31.4724,17.9079z"/>
   </g>
   <g>
       <path class="st0" d="M33.6677,18.0329h-13c-0.6904,0-1.25-0.5596-1.25-1.25s0.5596-1.25,1.25-1.25h13
           c0.6904,0,1.25,0.5596,1.25,1.25S34.3581,18.0329,33.6677,18.0329z"/>
   </g>
   <g>
       <path class="st0" d="M27.1677,9.2566c-0.6904,0-1.25-0.5596-1.25-1.25V1.5329c0-0.6904,0.5596-1.25,1.25-1.25
           s1.25,0.5596,1.25,1.25v6.4736C28.4177,8.697,27.8581,9.2566,27.1677,9.2566z"/>
   </g>
   <g>
       <path class="st0" d="M20.8737,39.6003c-0.0894,0-0.1807-0.0098-0.272-0.0303c-0.6738-0.1494-1.0991-0.8174-0.9492-1.4912
           c2.1196-9.5444,2.0571-16.5547,2.0273-19.9238l-0.0063-1.002c0-0.6904,0.5596-1.25,1.25-1.25s1.25,0.5596,1.25,1.25l0.0063,0.9795
           c0.0308,3.4619,0.0947,10.665-2.0869,20.4883C21.9636,39.2034,21.447,39.6003,20.8737,39.6003z"/>
   </g>
   <g>
       <path class="st0" d="M15.8132,55.7605c-0.1553,0-0.3135-0.0293-0.4663-0.0908c-0.6406-0.2578-0.9507-0.9854-0.6929-1.626
           c1.3853-3.4404,2.5859-6.9238,3.5693-10.3516c0.1899-0.665,0.8823-1.0498,1.5464-0.8564
           c0.6636,0.1904,1.0474,0.8818,0.8569,1.5459c-1.0073,3.5107-2.2363,7.0752-3.6533,10.5957
           C16.777,55.4646,16.3083,55.7605,15.8132,55.7605z"/>
   </g>
   <g>
       <path class="st0" d="M3.9235,78.4079H3.923l-2.3652-0.001c-0.6904,0-1.25-0.5605-1.2495-1.251
           c0.0005-0.6895,0.5601-1.249,1.25-1.249h0.0005l1.6836,0.001c3.5371-5.5127,6.6143-11.0996,9.1509-16.6162
           c0.2886-0.627,1.0308-0.9033,1.6582-0.6133c0.627,0.2881,0.9019,1.0312,0.6133,1.6582
           c-2.6743,5.8154-5.9351,11.7031-9.6924,17.501C4.7419,78.1931,4.3474,78.4079,3.9235,78.4079z"/>
   </g>
   <g>
       <path class="st0" d="M40.446,78.407h-3c-0.6904,0-1.25-0.5596-1.25-1.25s0.5596-1.25,1.25-1.25h1.1953
           c-2.3838-5.6104-5.9502-8.1357-11.3867-8.1357h-0.1729c-5.438,0-9.0039,2.5254-11.3867,8.1357h1.2012
           c0.6904,0,1.25,0.5596,1.25,1.25s-0.5596,1.25-1.25,1.25h-2.999c-0.3438,0-0.6729-0.1416-0.9087-0.3916
           c-0.3213-0.3398-0.4424-0.8477-0.2876-1.2891c2.7007-7.708,7.4048-11.4551,14.3809-11.4551h0.1729
           c6.9746,0,11.6787,3.7471,14.3809,11.4551c0.1182,0.3369,0.0859,0.708-0.0869,1.0205
           C41.3278,78.1433,40.9001,78.407,40.446,78.407z"/>
   </g>
   <g>
       <path class="st0" d="M50.4118,78.4079c-0.4238,0-0.8184-0.2148-1.0488-0.5703C29.8913,47.7898,30.0905,25.468,30.156,18.133
           l0.0059-0.98c0-0.6904,0.5596-1.25,1.25-1.25c0.6904,0,1.25,0.5596,1.25,1.25l-0.0059,1.0024
           c-0.0635,7.103-0.2559,28.6235,18.4365,57.7524l1.6641-0.001c0.001,0,0.001,0,0.001,0c0.6904,0,1.25,0.5596,1.25,1.249
           c0,0.6904-0.5596,1.251-1.249,1.251l-2.3457,0.001C50.4118,78.4079,50.4118,78.4079,50.4118,78.4079z"/>
   </g>
   <g>
       <path class="st0" d="M43.6052,60.9695h-32.875c-0.6904,0-1.25-0.5596-1.25-1.25s0.5596-1.25,1.25-1.25h32.875
           c0.6904,0,1.25,0.5596,1.25,1.25S44.2956,60.9695,43.6052,60.9695z"/>
   </g>
   <g>
       <path class="st0" d="M37.695,44.8747H16.6403c-0.6904,0-1.25-0.5596-1.25-1.25s0.5596-1.25,1.25-1.25H37.695
           c0.6904,0,1.25,0.5596,1.25,1.25S38.3854,44.8747,37.695,44.8747z"/>
   </g>
</g>
</svg>
)

